import { channelsRoutes } from "@/modules/channels/routes";
import { clientRoutes } from "@/modules/client/routes";
import { contentRoutes } from "@/modules/content/routes";
import { productsRoutes } from "@/modules/products/routes";
import { reportsRoutes } from "@/modules/reports/routes";
import { errorRoutes } from "@/shared/ui/views/errors/routes";

export const rootBasePath = "/:clientId?";

export const rootRoutesNames = {
  root: "root",
  home: () => `${rootRoutesNames.root}.home`,
};

export const routes = [
  {
    name: rootRoutesNames.root,
    path: `${rootBasePath}`,
    meta: {
      auth: true,
    },
    children: [
      {
        path: "",
        name: rootRoutesNames.home(),
        component: () => import("@/shared/ui/views/Empty.vue"),
      },
      ...productsRoutes,
      channelsRoutes,
      ...reportsRoutes,
      ...contentRoutes,
      ...clientRoutes,
    ],
  },
  errorRoutes,
];
